import Config from './../config.js';

class PeerConnection  {
    constructor(emitter, offerOptions, mediaStream) {
        this.emitter = emitter;
        var servers = Config.iceservers;
        this.mediaStream = mediaStream;
        this.offerOptions = offerOptions;
        this.iceQueue     = [];
        this.answered = false;

        let peer = new window.RTCPeerConnection(servers);
        this.peer = peer;

        this.peer.addEventListener("icecandidate", e => this.onIceCandidate(e));
    
        this.peer.addEventListener("iceconnectionstatechange", e =>
          this.onIceStateChange(e)
        );

        this.peer.addEventListener("track", e => this.gotRemoteStream(e));
        this.mediaStream
            .getTracks()
            .forEach(track => this.peer.addTrack(track, this.mediaStream));
    }

    async createOffer(){
        try {
            console.log("Customer video createOffer start");
            const offer = await this.peer.createOffer(this.offerOptions);
            await this.peer.setLocalDescription(offer);
            return offer;
          } catch (e) {}
    }

    async processOffer(offer) {
        await this.peer.setRemoteDescription(offer);
        const answer = await this.peer.createAnswer();
        console.log("processOffer " + answer);
        await this.peer.setLocalDescription(answer);
        this.answered = true;
        this._processIceQueue();
        return answer;
      }

      async processAnswer(answer) {
        await this.peer.setRemoteDescription(answer);
        this.answered = true;
        this._processIceQueue();

      }

      onIceCandidate(event) {
          console.log("onIceCandidate " +JSON.stringify(event.candidate));
        this.emitter.emit('iceCandidate', event.candidate);
      }

      async _processIceQueue() {
        while (this.iceQueue.length) {
          const candidate = this.iceQueue.shift();
          await this.peer.addIceCandidate(candidate);
        }
      }

      async handleIceCandidate(candidate) {
        if(!this.answered){
            this.iceQueue.push(candidate);
          }else{
            await this.peer.addIceCandidate(candidate);
          }
      }


      gotRemoteStream(e) {
        this.emitter.emit('remoteStream', e.streams[0]);
      }

      onIceStateChange(event) {
        console.log("onIceStateChange webrtc peer " + this.peer.iceConnectionState);
        this.emitter.emit('onIceStateChange', this.peer.iceConnectionState);
      }

      getPeerConnectionState(){
        return this.peer.iceConnectionState;
      }

      on(event, listener){
          this.emitter.on(event, listener);
      }

      closePeerConnection(){
        if(this.peer && this.peer.close)
        this.peer.close();
      }


      close(){
        console.log("Closing Peer Connection");
        if (this.mediaStream) {
            let tracks = this.mediaStream.getTracks();

            tracks.forEach(function(track) {
              track.stop();
            });
          }
          if(this.peer && this.peer.close)
            this.peer.close();
      }

      stopTracks(){
        this.mediaStream.getTracks().forEach(function(track) {
            track.stop();
          });
      }

      switchTracks(mediaStream){
        this.mediaStream = mediaStream;
        if (this.peer) {
            this.peer
              .getSenders()
              .map(sender =>
                sender.replaceTrack(
                  this.mediaStream
                    .getTracks()
                    .find(t => t.kind === sender.track.kind),
                  this.mediaStream
                )
              );
          }

      }

}

export default PeerConnection;